module.exports = __webpack_public_path__ + "static/media/a58.20ab8cc0.jpg";